import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['template', 'fieldPlacement', 'choice', 'defaultTemplate'];

  connect () {
    this.toggleFields();
  }

  toggleFields () {
    const template = this.templateTargets.find((templateTarget) => {
      if (templateTarget.dataset.choice === this.choiceTarget.value) {
        return templateTarget;
      }

      return null;
    });

    if (template) {
      this.fieldPlacementTarget.innerHTML = template.innerHTML;
    } else if (this.hasDefaultTemplateTarget) {
      this.fieldPlacementTarget.innerHTML = this.defaultTemplateTarget.innerHTML;
    }
  }
}
